import { render, staticRenderFns } from "./FightersModal.vue?vue&type=template&id=16b79244&lang=pug&"
import script from "./FightersModal.vue?vue&type=script&lang=js&"
export * from "./FightersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports